import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getAllExhibition = () => async (dispatch) => {
  const api = API_URLS.EXHIBITION.getAllExhibition();
  dispatch({
    type: TYPE.EXHIBITION.GET_ALL_EXHIBITION_LOADING,
    meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.EXHIBITION.GET_ALL_EXHIBITION_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.EXHIBITION.GET_ALL_EXHIBITION_FAILURE,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      }),
    );
  }
};

export const getFilteredExhibition = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.EXHIBITION.getFilteredExhibition(page, pageSize);
  dispatch({
    type: TYPE.EXHIBITION.GET_FILTERED_EXHIBITION_LOADING,
    meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.EXHIBITION.GET_FILTERED_EXHIBITION_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.EXHIBITION.GET_FILTERED_EXHIBITION_FAILURE,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      }),
    );
  }
};

export const getAllExhibitionByProfileId = (id) => async (dispatch) => {
  const api = API_URLS.EXHIBITION.getAllExhibitionByProfileId(id);
  dispatch({
    type: TYPE.EXHIBITION.GET_ALL_EXHIBITION_BY_PROFILE_ID_LOADING,
    meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.EXHIBITION.GET_ALL_EXHIBITION_BY_PROFILE_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.EXHIBITION.GET_ALL_EXHIBITION_BY_PROFILE_ID_FAILURE,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      }),
    );
  }
};

export const insertExhibition = (profileId, payload) => async (dispatch) => {
  const api = API_URLS.EXHIBITION.insertExhibition();
  dispatch({
    type: TYPE.EXHIBITION.INSERT_EXHIBITION_LOADING,
    meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.EXHIBITION.INSERT_EXHIBITION_SUCCESS,
      id: profileId,
      payload: response.data.data,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Thêm dữ liệu thành công!",
      }),
    );
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.EXHIBITION.INSERT_EXHIBITION_FAILURE,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Thêm dữ liệu thất bại!",
      }),
    );
    return { success: false, data: null };
  }
};

export const updateExhibition = (id, payload) => async (dispatch) => {
  const api = API_URLS.EXHIBITION.updateExhibition(id);
  dispatch({
    type: TYPE.EXHIBITION.UPDATE_EXHIBITION_LOADING,
    meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.EXHIBITION.UPDATE_EXHIBITION_SUCCESS,
      id,
      payload: response.data.data,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật dữ liệu thành công!",
      }),
    );
    return { success: true };
  } else {
    dispatch({
      type: TYPE.EXHIBITION.UPDATE_EXHIBITION_FAILURE,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_FAILURE] },
    });

    // Check for specific error codes
    const errorCode = response?.data?.error || response?.data?.message;
    if (errorCode && (errorCode.includes("ERR_HEMIS_DUPLICATE") || errorCode.includes("duplicate hemisCode"))) {
      return { success: false, error: "ERR_HEMIS_DUPLICATE", message: response?.data?.message };
    }

    dispatch(
      notification({
        type: "error",
        message: "Cập nhật dữ liệu thất bại!",
      }),
    );
    return { success: false };
  }
};

export const deleteExhibition = (id) => async (dispatch) => {
  const api = API_URLS.EXHIBITION.deleteExhibition(id);
  dispatch({
    type: TYPE.EXHIBITION.DELETE_EXHIBITION_LOADING,
    meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.EXHIBITION.DELETE_EXHIBITION_SUCCESS,
      id,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xoá dữ liệu thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.EXHIBITION.DELETE_EXHIBITION_FAILURE,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xoá dữ liệu thất bại!",
      }),
    );
    return false;
  }
};

export const acceptExhibition = (id, accept) => async (dispatch) => {
  const api = API_URLS.EXHIBITION.acceptExhibition(id, accept);
  dispatch({
    type: TYPE.EXHIBITION.ACCEPT_EXHIBITION_LOADING,
    meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.EXHIBITION.ACCEPT_EXHIBITION_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xác nhận thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.EXHIBITION.ACCEPT_EXHIBITION_FAILURE,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xác nhận thất bại!",
      }),
    );
    return false;
  }
};

export const checkDuplicateExhibition = (payload) => async (dispatch) => {
  const api = API_URLS.EXHIBITION.checkDuplicateExhibition();
  dispatch({
    type: TYPE.EXHIBITION.CHECK_DUPLICATE_EXHIBITION_LOADING,
    meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200) {
    dispatch({
      type: TYPE.EXHIBITION.CHECK_DUPLICATE_EXHIBITION_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_SUCCESS] },
    });
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.EXHIBITION.CHECK_DUPLICATE_EXHIBITION_FAILURE,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_FAILURE] },
    });
    notification({
      type: "error",
      message: "Kiểm tra trùng lặp thất bại!",
    });
    return { success: false, data: [], error: true };
  }
};

export const exportExhibition = (payload) => async (dispatch) => {
  const api = API_URLS.EXHIBITION.exportDynamic();
  dispatch({
    type: TYPE.EXHIBITION.EXPORT_EXHIBITION_LOADING,
    meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.EXHIBITION.EXPORT_EXHIBITION_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_SUCCESS] },
    });

    // Download the file
    const downloadApi = API_URLS.EXHIBITION.downloadExportFile(response.data.data.filePath);
    const downloadUrl = `${process.env.REACT_APP_DOMAIN}${downloadApi.endPoint}`;

    // Create a temporary link and trigger download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = response.data.data.fileName || "exhibition_export.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    dispatch(
      notification({
        type: "success",
        message: "Xuất dữ liệu thành công!",
      }),
    );
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.EXHIBITION.EXPORT_EXHIBITION_FAILURE,
      meta: { prefix: [PREFIX.EXHIBITION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: error?.message || "Xuất dữ liệu thất bại!",
      }),
    );
    return { success: false };
  }
};

